import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../services/users.service';

type PlatformServiceMode = 'any' | 'all';

@Directive({
  selector: '[appHasPlatformService]',
})
export class HasPlatformServiceDirective implements OnInit, OnDestroy {
  private required: string | string[] | null | undefined;
  private mode: PlatformServiceMode = 'any';
  private hasView = false;
  private subscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    private userService: UserService,
  ) {}

  @Input()
  set appHasPlatformService(value: string | string[] | null | undefined) {
    this.required = value;
    this.updateView();
  }

  @Input()
  set appHasPlatformServiceMode(value: PlatformServiceMode | null | undefined) {
    this.mode = value || 'any';
    this.updateView();
  }

  ngOnInit(): void {
    this.subscription = this.userService.currentUserPlatformServices$.subscribe(
      () => this.updateView(),
    );
    this.updateView();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    const allowed =
      this.mode === 'all'
        ? this.userService.hasAllPlatformServices(this.required)
        : this.userService.hasPlatformService(this.required);

    if (allowed && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!allowed && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }
}
